import { render, staticRenderFns } from "./ratingOfEventGroups.vue?vue&type=template&id=13b0be19&scoped=true&"
import script from "./ratingOfEventGroups.vue?vue&type=script&lang=js&"
export * from "./ratingOfEventGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0be19",
  null
  
)

export default component.exports